import React from "react";
import GreenSlider from "../../assets/sell/green-slider.svg";
import GreenSliderDot from "../../assets/sell/green-slider-dot.svg";
import BlueSlider from "../../assets/sell/blue-slider.svg";
import BlueSliderDot from "../../assets/sell/blue-slider-dot.svg";
import YellowSlider from "../../assets/sell/yellow-slider.svg";
import YellowSliderDot from "../../assets/sell/yellow-slider-dot.svg";
import PurpleSlider from "../../assets/sell/purple-slider.svg";
import PurpleSliderDot from "../../assets/sell/purple-slider-dot.svg";
import RedSlider from "../../assets/sell/red-slider.svg";
import RedSliderDot from "../../assets/sell/red-slider-dot.svg";

import { PERSONALITY_TEST_ASSESSMENT_ID } from "../../utils/general-config";

const TraitProgressBar = ({
  value,
  labelLeft,
  labelRight,
  text,
  assessmentId,
  t,
}) => {
  const green = {
    slider: GreenSlider,
    dot: GreenSliderDot,
    text: "#53AF65",
  };

  const blue = {
    slider: BlueSlider,
    dot: BlueSliderDot,
    text: "#36A2B8",
  };

  const purple = {
    slider: PurpleSlider,
    dot: PurpleSliderDot,
    text: "#805AED",
  };

  const yellow = {
    slider: YellowSlider,
    dot: YellowSliderDot,
    text: "#E4AE3A",
  };

  const red = {
    slider: RedSlider,
    dot: RedSliderDot,
    text: "#EF4444",
  };

  const displayImageColor = (labelLeft) => {
    switch (labelLeft) {
      case t("dashboard.personality_trait_type.i"):
        return blue;
      case t("dashboard.personality_trait_type.e"):
        return blue;
      case t("dashboard.bigfive_trait_type.n"):
        return blue;
      case t("dashboard.personality_trait_type.s"):
        return yellow;
      case t("dashboard.personality_trait_type.n"):
        return yellow;
      case t("dashboard.bigfive_trait_type.e"):
        return yellow;
      case t("dashboard.personality_trait_type.t"):
        return green;
      case t("dashboard.personality_trait_type.f"):
        return green;
      case t("dashboard.bigfive_trait_type.o"):
        return green;
      case t("dashboard.personality_trait_type.j"):
        return purple;
      case t("dashboard.personality_trait_type.p"):
        return purple;
      case t("dashboard.bigfive_trait_type.c"):
        return purple;
      case t("dashboard.bigfive_trait_type.a"):
        return red;
      default:
        return green;
    }
  };

  const textColorClass = displayImageColor(labelLeft).text;

  const getLeftPosition = (currentValue) => {
    return `${(currentValue / 100) * 100}%`; // calculate left position as a percentage
  };

  const getRightPosition = (currentValue) => {
    return `${100 - (currentValue / 100) * 100}%`; // calculate right position as a percentage
  };

  const getDirectionValue = (currentValue) => {
    if (currentValue < 50) {
      return {
        left: `calc(${getLeftPosition(currentValue)} - 10px)`, // adjusted calculation
      };
    } else if (currentValue > 50) {
      return {
        right: `calc(${getRightPosition(currentValue)} - 10px)`, // adjusted calculation
      };
    }

    return {
      left: `calc(50% - 10px)`, // adjusted calculation
    };
  };
  const isPersonalityTest =
    !!assessmentId && assessmentId === PERSONALITY_TEST_ASSESSMENT_ID;

  return (
    <>
      <div className="relative">
        <div className="flex pb-2 justify-between w-full">
          <span className="text-[#444C5E] text-[16px] md:text-[12px] lg:text-[16px] font-normal md:px-4">
            {labelLeft}
          </span>
          <span className="text-[#444C5E] text-[16px] md:text-[12px] lg:text-[16px] font-normal md:px-4">
            {isPersonalityTest ? labelRight : `${value}%`}
            {/* {labelRight} */}
          </span>
        </div>
        <div className="relative w-full md:px-4">
          <img
            src={displayImageColor(labelLeft).slider}
            alt="Green Slider"
            height={15}
            width={500}
          />

          <div className="relative ">
            <img
              src={displayImageColor(labelLeft).dot}
              alt="Slider Dot"
              className="absolute -top-6 lg:-top-7 md:top-[-1.6rem] w-10 md:w-6 lg:w-10 h-10 md:h-12"
              height={10}
              width={10}
              style={{
                ...getDirectionValue(value),
              }}
            />

            <div
              className={`absolute top-[35%] flex items-center mt-2`}
              // style={{
              //   ...getDirectionValue(
              //     value > 50 ? value - 3 : value < 50 ? value + 3 : 50
              //   ),
              // }}
              style={{
                ...getDirectionValue(
                  value > 50 && value < 60
                    ? 38
                    : value > 50
                    ? value - 3
                    : value < 50
                    ? value + 3
                    : 50
                ),
              }}
            >
              <span
                id="green-slider-percentage"
                className="inline-block text-[#444C5E] text-[16px] md:text-[12px] lg:text-[16px] font-bold"
              >
                {isPersonalityTest && `${value}%`}
              </span>
              &nbsp;
              <span
                className={`inline-block text-[16px] md:text-[12px] lg:text-[16px] font-bold`}
                style={{ color: textColorClass }}
              >
                {isPersonalityTest && text}
                {/* {text} */}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TraitProgressBar;
